import React from "react"
import ChartODD13GHGEmissionsInternalExternalMolecule from "views/molecules/canvases/charts/ChartODD13GHGEmissionsInternalExternalMolecule"
import ChartOdd13ExternalAppEmissions from "views/molecules/canvases/charts/ChartOdd13ExternalAppEmissions"
import PropTypes from "prop-types"
import ChartSdg13WorkplaceEquipmentPerAllocation from "views/molecules/canvases/charts/ChartSDG13WorkplaceEquipmentPerAllocation"
import ChartCommuteVSTravel from "views/organisms/canvases/charts/ITDomainAnalysis/dispatcher/ChartCommuteVSTravel"
import BrokerManufBreakdown from "views/molecules/charts/brocker/BrokerManufBreakdown"
import ChartCloudServiceCostsDispatcher from "views/organisms/canvases/charts/ITDomainAnalysis/dispatcher/ChartCloudServiceCostsDispatcher"
import ChartQuantitativeCo2ImpactsMolecule from "views/molecules/canvases/charts/websites/ChartQuantitativeCo2ImpactsMolecule"
import { useTranslation } from "react-i18next"

const Chart3Sdg13Country = ({ score }) => {
  const { t } = useTranslation()

  if (score?.odd13_ghg_internal_external_spit)
    return (
      <ChartODD13GHGEmissionsInternalExternalMolecule
        ghgSplit={score?.odd13_ghg_internal_external_spit}
      />
    )

  if (score?.odd13_workplace_emission_split_per_allocation) {
    return <ChartSdg13WorkplaceEquipmentPerAllocation score={score} />
  }

  if (score?.has_significant_assets_impacts) {
    return <BrokerManufBreakdown score={score.assets_impacts} />
  }

  if (score?.saas) {
    return <ChartOdd13ExternalAppEmissions score={score.saas} />
  }

  if (score?.cloud_score) {
    return <ChartCloudServiceCostsDispatcher envScore={score} />
  }

  if (score?.website_analyse?.quantitative_co2_impacts?.length > 0) {
    return (
      <ChartQuantitativeCo2ImpactsMolecule
        mixedChart={score.website_analyse.quantitative_co2_impacts}
        title={t(
          "analyze:it_domain.cloud.kpis.digital_services_emissions.title"
        )}
      />
    )
  }

  return <ChartCommuteVSTravel envScore={score} showBarLabel />
}

Chart3Sdg13Country.propTypes = {
  score: PropTypes.object.isRequired,
}

export default Chart3Sdg13Country
